import React from 'react'

const OffersList = () => {
  return (
    <div>OffersList</div>
  )
}

export default OffersList